import { DownloadWrapper, Download } from '@/components/accountSettings/termsAndCondition/TermsAndConditions';
import { StyledLink } from '@/components/common';
import { styled, SxProps, Theme, Typography } from '@mui/material';
import { usePdfDownload } from '@/components/hooks/usePdfDownload';
import { breakpoints, spacing } from '@/theme/tokens';

const StyledDownloadWrapper = styled(DownloadWrapper)`
    margin-top: ${spacing[32]};
    align-items: flex-end !important;
    @media (max-width: ${breakpoints.md}) {
        margin-top: ${spacing[24]};
    }
    @media (max-width: ${breakpoints.sm}) {
        align-items: center !important;
        margin-top: ${spacing[16]};
    }
`;

export default function HTMLDownloadWrapper({
    filename,
    downloadButtonText,
    downloadText,
    htmlContent,
    sx,
    customStyles,
}: {
    filename: string;
    downloadButtonText: string;
    downloadText: string;
    htmlContent: string;
    sx?: SxProps<Theme>;
    customStyles?: string;
}) {
    const { downloadPdf } = usePdfDownload();

    const isDownloadButtonOneLine = downloadButtonText.length <= 5;

    const handleDownloadPdf = () => {
        if (filename && htmlContent) {
            downloadPdf(htmlContent, filename, customStyles);
        }
    };

    return (
        <StyledDownloadWrapper sx={sx}>
            <Download
                sx={{
                    flexDirection: {
                        xs: isDownloadButtonOneLine ? 'row !important' : 'column !important',
                        sm: 'row !important',
                    },
                    gap: {
                        xs: isDownloadButtonOneLine ? `${spacing[8]} !important` : `${spacing[0]} !important`,
                        sm: `${spacing[8]} !important`,
                    },
                }}
            >
                <Typography variant="label5medium">{downloadText}</Typography>
                <StyledLink
                    onClick={handleDownloadPdf}
                    tabIndex={0}
                    onKeyDown={(e: React.KeyboardEvent) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            handleDownloadPdf();
                        }
                    }}
                    variant="label5medium"
                    className="brand"
                    showUnderline={true}
                >
                    {downloadButtonText}
                </StyledLink>
            </Download>
        </StyledDownloadWrapper>
    );
}
